export const IMAGES = {
  founderDawn:
    "https://static.prod-images.emergentagent.com/jobs/e97d0baa-bb7a-4664-822e-e05554a7b5ab/images/a0decc186af082891a90a3f099367bc708797d862a80c263d82f32955bd5867b.jpeg",
  founderDesk:
    "https://static.prod-images.emergentagent.com/jobs/e97d0baa-bb7a-4664-822e-e05554a7b5ab/images/35e6dd02e727039a46e74058d82bd87ef6db14d33a893e17081bc469d665e437.jpeg",
  architecture:
    "https://static.prod-images.emergentagent.com/jobs/e97d0baa-bb7a-4664-822e-e05554a7b5ab/images/c917a0203a7a757c69f7d5069a65f4c0acc3cf985d04e823a05a11940c564857.jpeg",
  founderPortrait:
    "https://customer-assets-jai6qajn.emergentagent.net/job_capacity-system/artifacts/nxvo5zd4_ChatGPT%20Image%202%20sept.%202026%2C%2018_26_56.png",
  founderDoctor:
    "https://customer-assets-jai6qajn.emergentagent.net/job_capacity-system/artifacts/doz6787f_ChatGPT%20Image%201%20sept.%202026%2C%2015_43_38.png",
};
